(() => {
  const desktop = matchMedia('(min-width:750px)');
  const icon = document.querySelector('link[rel~="icon"]');
  const originalIcon = icon?.getAttribute('href');
  const desktopIcon = document.querySelector('[data-neuer-desktop-icon]')?.dataset.neuerDesktopIcon;
  const links = new Map();
  const videos = new Set();
  const update = () => {
    document.querySelectorAll('[data-desktop-href]').forEach(link => {
      if (!links.has(link)) links.set(link, link.getAttribute('href'));
      link.setAttribute('href', desktop.matches ? link.dataset.desktopHref : links.get(link));
    });
    if (icon && desktopIcon) icon.setAttribute('href', desktop.matches ? desktopIcon : originalIcon);
    document.querySelectorAll('[data-neuer-desktop-fade] video').forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      const root = video.closest('[data-neuer-desktop-fade]');
      const copy = root.querySelector('.neuer-editorial-footer__content');
      const fade = () => {
        if (!copy) return;
        const percent = Number(root.dataset.neuerDesktopFade) || 78;
        const start = video.duration * percent / 100;
        const end = Math.max(.1, video.duration - start);
        const opacity = desktop.matches && Number.isFinite(video.duration)
          ? Math.max(0, Math.min(1, (video.duration - video.currentTime) / end)) : 1;
        copy.style.setProperty('--nd-video-copy-opacity', String(opacity));
      };
      video.addEventListener('timeupdate', fade);
      video.addEventListener('loadedmetadata', fade);
      desktop.addEventListener('change', fade);
      fade();
    });
  };
  desktop.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
  update();
})();
